import script from "./TopCarouselsChart.vue?vue&type=script&setup=true&lang=js"
export * from "./TopCarouselsChart.vue?vue&type=script&setup=true&lang=js"

import "./TopCarouselsChart.vue?vue&type=style&index=0&id=306ee6e8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-306ee6e8"]])

export default __exports__